export const AUTHOR_THUMBNAIL_SRC="https://avatars.githubusercontent.com/u/45337164?s=400&u=189572e08cf2a7d3547556b33eabf28e5f3596ed&v=4";
export const AUTHOR_NAME="Lontoone";
//export const SELF_IMG="https://i.imgur.com/2B6L6Ad.png";
//export const SELF_IMG="https://i.imgur.com/96E7pw1.png";
//export const SELF_IMG="https://i.imgur.com/2U3WTm3.png";
export const SELF_IMG="https://i.imgur.com/Qe8eBPi.png";
export const LINK_DATAS_ROOT="https://lontoone.github.io/data/links/";
